import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import ECharts from '~/components/echarts'
import { organizationAWSRDSOptimizationRightSizeRecommendationMemoryChartPath } from '~/routes'

export default function AwsRdsMemoryRightSizeRecommendationsCharts({
  organizationId: orgId,
  resourceId: reId,
  optimizationId: optId,
}) {
  const params = { metrics_time_frame: '1w' }

  const RDSMemoryChartUrl = useMemo(
    () => organizationAWSRDSOptimizationRightSizeRecommendationMemoryChartPath(orgId, optId, reId),
    [orgId, optId, reId],
  )
  return (
    <div className='card'>
      <div className='card-body'>
        <div className='row g-0'>
          <div className='col-sm-12'>
            <ECharts
              title={t`Memory Utilization`}
              chartInfoTitle='aws_rds_recommendations_memory_utilization'
              url={RDSMemoryChartUrl}
              params={params}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
